import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-property-division-form-pj',
  templateUrl: './property-division-form-pj.component.html',
  styleUrls: ['./property-division-form-pj.component.scss'],
})
export class PropertyDivisionFormPjComponent {
  constructor(private router: Router) {}


  backStep() {
    this.router.navigateByUrl('forms-list');
  }

}
